import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserPreferenceType } from '../../constants/UserPreferences';

export type IUserDashboardPreferenceResponse = {
  preference: string; // dashboardPreference
  fieldNomsPreference: string; // fieldNomsPreference
};

export type ISaveUserPreferencePayload = {
  type: UserPreferenceType;
  preference: string;
};

export interface IUserDashboardPreferencesState {
  raw: IUserDashboardPreferenceResponse | null; // Changed from array to single object
  dashboardPreference: string;
  fieldNomsPreference: string;
}

const initialState: IUserDashboardPreferencesState = {
  raw: null,
  dashboardPreference: '[]',
  fieldNomsPreference: '[]',
};

const userDashboardPreferencesSlice = createSlice({
  name: 'userDashboardPreferences',
  initialState,
  reducers: {
    setUserDashboardPreferences(
      state,
      action: PayloadAction<IUserDashboardPreferenceResponse>
    ) {
      state.raw = action.payload;
      // Directly assign the preference strings from the new API response
      state.dashboardPreference = action.payload.preference || '[]';
      state.fieldNomsPreference = action.payload.fieldNomsPreference || '[]';
    },
  },
});

export const { setUserDashboardPreferences } =
  userDashboardPreferencesSlice.actions;

export default userDashboardPreferencesSlice.reducer;
